import React from "react";
import './styles/new-site.css';

const NewSite = () => {
  return (
<main class="content">
        <p style={{ textIndent: '20px'}}> <b>На данный момент создаётся новый сайт МТВ &#40;этот&#41;. Здесь приведены некоторые типовые вопросы и ответы на них. </b></p>
        <h3 style={{ textAlign: 'center' }}>Поддержка старой версии прекращена 1 февраля 2024 года.</h3>
        <h2 class="question">Почему создаётся новый сайт?</h2>
        <p class="answer">Новый сайт создаётся по причине не соотвествия моим требованиям, в гугл сайтах слишком много мелких нюансов, с которыми я не хочу мириться. Поэтому я решил написать сайт с нуля, чтобы сделать его по своему вкусу.</p>
        <h2 class="question">Что будет со старой версией?</h2>
        <p class="answer">Поддержка старой версии прекращена. Доступ к ней будет осуществляться по <a class="shit" href= "https://old.mtv-media.ru">этой</a> ссылке до июня 2024. После этого при переходе по этой ссылке будет пересылка на новую версию.</p>
        <h2 class="question">Насколько долго будет делаться новая версия сайта?</h2>
        <p class="answer">Точных сроков дать нельзя. Процесс этот не такой уж и простой, но возможно, создание закончится к июню 2024 года.</p>
        <script src="/scripts/new-site-qa.js"></script>
    </main>
    );
};

export default NewSite;